import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57f895cd")

_pushScopeId("data-v-57f895cd")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "pi pi-trash" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "pi pi-chevron-right" }, null, -1)
const _hoisted_3 = { class: "list-task" }
const _hoisted_4 = {
  class: "p-text-nowrap p-text-truncate",
  style: {"width":"20.5rem"}
}
const _hoisted_5 = {
  class: "p-text-nowrap p-text-truncate",
  style: {"width":"20.5rem"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Knob = _resolveComponent("Knob")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Panel = _resolveComponent("Panel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", {
    class: ["layout-sidebar-right p-p-0 custome-task-popup-size", {
      'layout-sidebar-right-active custome-task-popup-location': _ctx.isShow,
    }]
  }, [
    _createVNode(_component_Panel, {
      header: _ctx.getHeader()
    }, {
      icons: _withId(() => [
        _withDirectives(_createVNode("button", {
          class: "p-panel-header-icon p-link p-mr-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
        }, [
          _hoisted_1
        ], 512), [
          [
            _directive_tooltip,
            _ctx.$t('task.upload.file.clear'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode("button", {
          class: "p-panel-header-icon p-link p-mr-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _hoisted_2
        ], 512), [
          [
            _directive_tooltip,
            _ctx.$t('task.upload.file.close'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          (_ctx.isHavingTask())
            ? (_openBlock(), _createBlock(_component_DataView, {
                key: 0,
                value: _ctx.getAllTask,
                layout: "list"
              }, {
                list: _withId((slotProps) => [
                  _createVNode(_component_router_link, {
                    to: slotProps.data.datasourcePath,
                    class: "p-d-flex p-jc-between p-ai-center p-p-2"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_4, _toDisplayString(slotProps.data.fileName), 1),
                      (_ctx.isSuccess(slotProps.data.status))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "pi pi-check",
                            class: "p-button-rounded p-button-success"
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              slotProps.data.doneTime,
                              void 0,
                              { left: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.isFailed(slotProps.data.status))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            icon: "pi pi-exclamation-circle",
                            class: "p-button-rounded p-button-warning"
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              slotProps.data.message,
                              void 0,
                              { left: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.isUploading(slotProps.data.status))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Knob, {
                            key: 2,
                            class: "p-m-0",
                            modelValue: 
                  (
                    (slotProps.data.loadedBytes * 100) /
                    slotProps.data.totalBytes
                  ).toFixed(0)
                ,
                            min: 0,
                            max: 100,
                            size: "33",
                            strokeWidth: "8"
                          }, null, 8, ["modelValue"])), [
                            [
                              _directive_tooltip,
                              slotProps.data.doneTime,
                              void 0,
                              { left: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }, 8, ["value"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: '/datasource',
                class: "p-d-flex p-jc-between p-ai-center p-p-2"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("task.upload.file.do.not.have")), 1)
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }, 8, ["header"])
  ], 2))
})